import qs from "qs";

const getPrefilled = () => {
  const filter = /^form_/;
  const query = [];
  Object.entries(qs.parse(window.location.search.substring(1))).forEach(
    (value) => {
      if (value[0].match(filter)) {
        query[value[0].replace(filter, "")] = value[1];
      }
    }
  );
  return query;
};

export default getPrefilled;
